export const expertListEn = {
    ssts:"Experts name",
    ytxshfl:"24-hour response rate"
}


// WEBPACK FOOTER //
// ./src/lang/home/expertList/indexEn.js